import { render, staticRenderFns } from "./Archive-messages.vue?vue&type=template&id=2aeb20fc&scoped=true&"
import script from "./Archive-messages.vue?vue&type=script&lang=js&"
export * from "./Archive-messages.vue?vue&type=script&lang=js&"
import style0 from "./Archive-messages.vue?vue&type=style&index=0&id=2aeb20fc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aeb20fc",
  null
  
)

export default component.exports